export const logErrors = (message: string, value?: unknown): void => {
  console.error(message, value);
};
